(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/win-div/assets/javascripts/win-div.js') >= 0) return;  svs.modules.push('/components/tipsen/win-div/assets/javascripts/win-div.js');
"use strict";

const format = svs.utils.format;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const useCombinedDrawAndPlayerWinDivs = svs.components.tipsen.winDiv.useCombinedDrawAndPlayerWinDivs;
const getCorrectAmountHeaderText = svs.components.tipsen.winDiv.utils.getCorrectAmountHeaderText;
const getWinDivRowClassNames = function (branding) {
  let playerWins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let isMultiForecastChoiceOnCorrectResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const classNames = ['pg_windiv_grid'];
  if (branding && branding.length > 0) {
    classNames.push("pg_windiv_grid--".concat(branding));
  }
  if (playerWins > 0 && isMultiForecastChoiceOnCorrectResult) {
    classNames.push('pg_windiv_grid__highlighted');
    if (branding && branding.length > 0) {
      classNames.push("pg_windiv_grid__highlighted--".concat(branding));
    }
  }
  return classNames;
};
const WinDiv = _ref => {
  let branding = _ref.branding,
    drawWinDivs = _ref.drawWinDivs,
    playerWinDivs = _ref.playerWinDivs,
    _ref$drawEventsLength = _ref.drawEventsLength,
    drawEventsLength = _ref$drawEventsLength === void 0 ? 13 : _ref$drawEventsLength,
    className = _ref.className,
    _ref$headerText = _ref.headerText,
    headerText = _ref$headerText === void 0 ? '' : _ref$headerText,
    isDrawCompleted = _ref.isDrawCompleted,
    isGroup = _ref.isGroup,
    _ref$isSportkryss = _ref.isSportkryss,
    isSportkryss = _ref$isSportkryss === void 0 ? false : _ref$isSportkryss,
    hasPlayerWinDivs = _ref.hasPlayerWinDivs,
    isMultiForecastChoiceOnCorrectResult = _ref.isMultiForecastChoiceOnCorrectResult,
    isGoalCount = _ref.isGoalCount;
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const hasPlayerData = Boolean(playerWinDivs) && hasPlayerWinDivs && !(isGoalCount && !isMultiForecastChoiceOnCorrectResult);
  const combinedWinDivData = useCombinedDrawAndPlayerWinDivs({
    playerWinDivs,
    drawWinDivs
  });
  const winDivClasses = ['pg_windiv'];
  if (className) {
    winDivClasses.push(className);
  }
  return React.createElement("section", null, headerText.length > 0 && React.createElement("h1", {
    className: "h3 f-center margin-bottom-1"
  }, headerText), React.createElement("div", {
    className: winDivClasses.join(' '),
    role: "table"
  }, React.createElement("header", {
    className: "margin-bottom-half",
    role: "rowgroup"
  }, React.createElement("div", {
    className: "pg_windiv_grid pg_windiv_grid--header",
    role: "row"
  }, React.createElement("div", {
    className: "pg_windiv_grid__correct_amounts",
    role: "columnheader"
  }, "Antal r\xE4tt"), React.createElement("div", {
    className: "pg_windiv_grid__win_commission",
    role: "columnheader"
  }, "Utdelning ".concat(isDrawCompleted || isSportkryss ? '' : 'just nu')), React.createElement("div", {
    className: "pg_windiv_grid__correct_rows",
    role: "columnheader"
  }, getCorrectAmountHeaderText({
    isSportkryss,
    hasPlayerData,
    isGroup,
    isExtraSmall
  })))), React.createElement("ol", {
    className: "pg_windiv_rowgroup",
    role: "rowgroup",
    translate: "no"
  }, combinedWinDivData.map(_ref2 => {
    let winDiv = _ref2.winDiv,
      winValue = _ref2.winValue,
      odds = _ref2.odds,
      winners = _ref2.winners,
      playerWins = _ref2.playerWins;
    return React.createElement("li", {
      className: getWinDivRowClassNames(branding, playerWins, isMultiForecastChoiceOnCorrectResult).join(' '),
      key: winDiv,
      role: "row"
    }, React.createElement("span", {
      className: "pg_windiv_grid__correct_amounts",
      role: "cell"
    }, isSportkryss ? "".concat(winDiv) : "".concat(drawEventsLength - (winDiv - 1))), !odds && React.createElement("span", {
      className: "pg_windiv_grid__win_commission",
      role: "cell"
    }, "".concat(format.Currency(winValue), " kr")), odds && React.createElement("span", {
      className: "pg_windiv_grid__win_commission",
      role: "cell"
    }, odds === '0,00' ? 'Rullpott' : "Odds: ".concat(format.Odds(odds))), React.createElement("span", {
      className: "pg_windiv_grid__correct_rows",
      role: "cell"
    }, "".concat(format.Currency(winners), " st"), hasPlayerData && " (".concat(playerWins, " st)")));
  }))));
};
setGlobal('svs.components.tipsen.winDiv.WinDiv', WinDiv);

 })(window);